// @ts-strict-ignore
import { forwardRef, type PropsWithChildren } from 'react';
import { styled } from 'styled-components';

import { getMediaQuery } from '~/utils/responsive/media';

import { MainContainer } from './mainContainer';

type Padding = { top?: number; left?: number; right?: number; bottom?: number };

const getPadding =
  (side: keyof Padding, defaultValue: number) =>
  ({ $padding }: { $padding?: Padding }) =>
    `padding-${side}: ${$padding?.[side] > defaultValue ? defaultValue : ($padding?.[side] ?? defaultValue)}px`;

export const StyledContainer = styled.div<{ $padding?: Padding }>`
  width: 100%;
  max-width: ${({ theme }) => theme.sizes?.maxBodyWidth};
  margin: 0 auto;
  position: relative;
  ${getPadding('left', 24)};
  ${getPadding('right', 24)};
  ${getPadding('top', 56)};
  ${getPadding('bottom', 56)};

  ${getMediaQuery('tablet')} {
    ${getPadding('left', 24)};
    ${getPadding('right', 24)};
    ${getPadding('top', 32)};
    ${getPadding('bottom', 32)};
  }

  ${getMediaQuery('mobile')} {
    ${getPadding('left', 24)};
    ${getPadding('right', 24)};
    ${getPadding('top', 32)};
    ${getPadding('bottom', 32)};
  }
`;

export const Container = forwardRef<HTMLDivElement, PropsWithChildren<{ padding?: Padding }>>(
  ({ children, padding, ...props }, ref) => (
    <MainContainer {...props} ref={ref}>
      <StyledContainer $padding={padding}>{children}</StyledContainer>
    </MainContainer>
  ),
);
